import React, { useState, useEffect } from "react";
import "./LecturerDashboard.scss";

interface Grievance {
  id: number;
  subject: string;
  description: string;
  status: string;
  comments: string;
}

const LecturerDashboard: React.FC = () => {
  const [grievances, setGrievances] = useState<Grievance[]>([]);
  const [comment, setComment] = useState<{ [key: number]: string }>({});
  const [status, setStatus] = useState<{ [key: number]: string }>({});

  useEffect(() => {
    fetch("http://sjmpolytechnicbirur.in/api/get_grievances.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.grievances)) {
          setGrievances(data.grievances);
        } else {
          setGrievances([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching grievances:", err);
        setGrievances([]);
      });
  }, []);
  

  const handleCommentChange = (id: number, value: string) => {
    setComment((prev) => ({ ...prev, [id]: value }));
  };

  const handleStatusChange = (id: number, value: string) => {
    setStatus((prev) => ({ ...prev, [id]: value }));
  };

  const handleUpdate = async (id: number) => {
    const response = await fetch("http://sjmpolytechnicbirur.in/api/update_grievance.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ grievance_id: id, status: status[id] || "Pending", comment: comment[id] || "" }),
    });

    const result = await response.json();
    if (result.success) {
      alert("Grievance updated successfully");
      window.location.reload();
    } else {
      alert("Failed to update grievance");
    }
  };

  const handleLogout = async () => {
    try {
      await fetch("http://sjmpolytechnicbirur.in/api/logout.php", { credentials: "include" }); // Call PHP logout
      localStorage.removeItem("user"); // Remove user data from localStorage
      window.location.href = "/login"; // Redirect to login page
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <div className="lecturer-dashboard">
      <h1>Lecturer Dashboard</h1>
      <button className="logout-btn" onClick={handleLogout}>
  Logout
</button>
      <div className="grievance-list">
        {Array.isArray(grievances) && grievances.map((g) => (
          <div key={g.id} className="grievance-card">
            <h3>{g.subject}</h3>
            <p>{g.description}</p>
            <p>Status: <span className={`status ${g.status.toLowerCase()}`}>{g.status}</span></p>
            <p>Comments: {g.comments || "No comments yet"}</p>
            <div className="actions">
            <select
  onChange={(e) => handleStatusChange(g.id, e.target.value)}
  value={status[g.id] || g.status}  // ✅ Use value instead of defaultValue
>
  <option value="Pending">Pending</option>
  <option value="In Progress">In Progress</option>
  <option value="Resolved">Resolved</option>
</select>

              <input
                type="text"
                placeholder="Add a comment"
                value={comment[g.id] || ""}
                onChange={(e) => handleCommentChange(g.id, e.target.value)}
              />
              <button onClick={() => handleUpdate(g.id)}>Update</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LecturerDashboard;
